import { render } from "./Sign.vue?vue&type=template&id=3f1e6d58&scoped=true"
import script from "./Sign.vue?vue&type=script&lang=js"
export * from "./Sign.vue?vue&type=script&lang=js"

import "./Sign.vue?vue&type=style&index=0&id=3f1e6d58&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1e6d58"]])

export default __exports__